import {ai} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'
import type {AIPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<AIPublicAPI> {
    const {
        extensionPublicAPI: {getter, dataManipulation, immediate},
        defineAction,
        defineDataManipulationAction
    } = publicMethodUtils

    return {
        methods: {
            ai: {
                images: {
                    generateSimilarImages: dataManipulation('ai.images.generateSimilarImages'),
                    matchImagesToPage: dataManipulation('ai.images.matchImagesToPage'),
                    fitImagesToFrame: dataManipulation('ai.images.fitImagesToFrame'),
                    removeImagesBackground: dataManipulation('ai.images.removeImagesBackground'),
                    editImages: dataManipulation('ai.images.editImages'),
                    upscaleImages: dataManipulation('ai.images.upscaleImages'),
                    enhanceImages: dataManipulation('ai.images.enhanceImages'),
                    getLogoMediaObject: getter('ai.images.getLogoMediaObject'),
                    editLogos: dataManipulation('ai.images.editLogos'),
                    generateSingleImage: dataManipulation('ai.images.generateSingleImage'),
                    generateImagesFromDescriptions: immediate('ai.images.generateImagesFromDescriptions')
                },
                content: {
                    updatePageContent: defineDataManipulationAction(ai.applyOutline, {
                        asyncPreDataManipulation: ai.getSuggestedOutline,
                        isAsyncOperation: true
                    }),
                    updateComponentBuilderContent: dataManipulation('ai.content.updateComponentBuilderContent'),
                    updateComponentBuilderVideo: dataManipulation('ai.content.applyBuilderVideoInjection'),
                    updateComponentBuilderSvg: dataManipulation('ai.content.applyBuilderSvgInjection'),
                    updateComponentBuilderImage: dataManipulation('ai.content.getComponentInjectionForImageBuilder'),
                    updateComponentBuilderImageForSiteCreation: dataManipulation(
                        'ai.content.getImageInjectionForSiteCreation'
                    ),
                    updateSiteContent: defineDataManipulationAction(ai.applyOutlines, {
                        asyncPreDataManipulation: ai.getSuggestedSiteOutlines,
                        isAsyncOperation: true
                    }),
                    generatePageLinks: defineDataManipulationAction(ai.generateLinksForOutline, {
                        asyncPreDataManipulation: ai.getPageLinksOutline,
                        isAsyncOperation: true
                    }),
                    generatePagesLinks: defineDataManipulationAction(ai.generatesLinksForOutline, {
                        asyncPreDataManipulation: ai.getPagesLinksOutline,
                        isAsyncOperation: true
                    }),
                    getContentByStructure: defineAction(ai.getSuggestedOutlineByStructure),
                    getContentByPageStructure: defineDataManipulationAction(ai.applyOutlineToPageStructure, {
                        asyncPreDataManipulation: ai.getSuggestedOutlineByPageStructure,
                        isAsyncOperation: true
                    }),
                    getContentByStructures: defineAction(ai.getSuggestedOutlineByStructures),
                    updateContentByPageStructure: defineDataManipulationAction(ai.applyOutlineToPage, {
                        asyncPreDataManipulation: ai.getSuggestedOutlineByPageStructure,
                        isAsyncOperation: true
                    }),
                    getPageOutline: getter('ai.content.getPageOutline'),
                    applyOutline: dataManipulation('ai.content.applyOutline'),
                    uploadAndInjectImages: defineDataManipulationAction(() => {}, {
                        asyncPreDataManipulation: ai.uploadAndInjectImages,
                        isAsyncOperation: true
                    })
                },
                proactiveAssistance: {
                    suggest: immediate('ai.proactiveAssistance.suggest'),
                    applyRecommendations: immediate('ai.proactiveAssistance.applyRecommendations')
                }
            }
        }
    }
}
